import Vue from 'vue'

import PageLayout from '@/components/layouts/PageLayout'
import CustomDialog from '@/components/generic/CustomDialog'

Vue.component('page-layout', PageLayout)
Vue.component('custom-dialog', CustomDialog)
